import React from 'react'
import '../styles/link.scss'
export const Link = ({ link, children }) => (
    <a className="link" href={link} target="_blank" rel="noopener noreferrer">{children}</a>
)